import { deDE, enUS, frFR } from '@mui/x-data-grid-pro/locales';

export function setDataGridLocale() {
  const lang = localStorage.getItem('i18nextLng');
  if (lang === 'en') {
    return enUS.components.MuiDataGrid.defaultProps.localeText;
  }
  if (lang === 'fr') {
    return frFR.components.MuiDataGrid.defaultProps.localeText;
  }
  return deDE.components.MuiDataGrid.defaultProps.localeText;
}
